<button class="menu-button" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen" aria-label="Options menu">{{buttonIcon}}</button>
<div class="menu-backdrop" *ngIf="isMenuOpen" (click)="closeMenu()"></div>
<div class="menu-dropdown" *ngIf="isMenuOpen">
  <button *ngFor="let item of items" (click)="onItemClick(item.action)">
    {{ item.label | translate }}
  </button>
</div>